import { render, staticRenderFns } from "./AdminMasterPage.vue?vue&type=template&id=cb0e1d4c&"
import script from "./AdminMasterPage.vue?vue&type=script&lang=ts&"
export * from "./AdminMasterPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports